import React from 'react'
import {
  Div,
  ListItem,
  SelectableCard,
  UserCard,
} from '@sendoutcards/quantum-design-ui'
import { useQueries, useSelector } from 'src/hooks'
import { getSponsors, SponsorFragment } from 'src/graphql'
import { formatLocation } from 'src/helpers'
import NoResultsPlaceholder from 'src/onboarding/components/NoResultsPlaceHolder'
import SearchForSponsorPlaceholder from 'src/onboarding/components/SearchForSponsorPlaceHolder'

const SponsorSearchResult = (props: {
  search: string
  selectedSponsor?: SponsorFragment
  setSelectedSponsor: (sponsor?: SponsorFragment) => void
}) => {
  const { search, selectedSponsor, setSelectedSponsor } = props
  const [filteredSponsors] = useQueries(
    search.length > 0 ? getSponsors({ search }) : undefined,
  )
  const { isMobile } = useSelector(state => state.window)
  const maxLength = isMobile ? 10 : 12
  const formatName = (name: string) => {
    if (name.length === 0) return ' '
    if (name.length > maxLength) return `${name.substring(0, maxLength)}...`
    return name
  }

  return (
    <Div overflow="auto" flexDirection="column" height="100%" width="100%">
      {filteredSponsors &&
        filteredSponsors.length > 0 &&
        filteredSponsors.map(sponsor => {
          return (
            <ListItem
              key={sponsor.id}
              orientation="vertical"
              inset={{ top: 'x1' }}
            >
              <SelectableCard
                isActive={selectedSponsor?.id === sponsor.id}
                onClick={() => {
                  selectedSponsor !== sponsor
                    ? setSelectedSponsor(sponsor)
                    : setSelectedSponsor(undefined)
                }}
              >
                <UserCard
                  profileImage={sponsor.storefront?.mugshot?.url}
                  firstName={formatName(sponsor.firstName)}
                  lastName={formatName(sponsor.lastName)}
                  caption={formatLocation(
                    sponsor.shippingAddress?.city,
                    sponsor.shippingAddress?.state,
                  )}
                  size="small"
                  active={selectedSponsor?.id === sponsor.id}
                />
              </SelectableCard>
            </ListItem>
          )
        })}
      {search.length > 0 &&
        filteredSponsors &&
        filteredSponsors.length === 0 && (
          <NoResultsPlaceholder search={search} />
        )}
      {filteredSponsors === undefined && <SearchForSponsorPlaceholder />}
    </Div>
  )
}

export default SponsorSearchResult
